import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveInformation, updateInformation } from './actions';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import SelectField from '../../components/common/SelectField';
import DropNCropField from '../../components/common/DropNCropField';
import { INFORMATION_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class InformationForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const informationRequestData = {
      title: formProps.title,
      subtitle: formProps.subtitle,
      content: formProps.content,
      description: formProps.description,
      header: formProps.header,
      headerImageLarge: formProps.headerImageLarge.result,
      slug: formProps.slug
    };

    if (config && config.id) {
      // add new mutation for existing information
      this.props.updateInformation(
        informationRequestData,
        config.id,
        lang,
        () => {
          this.props.history.push('/informace');
        }
      );
    } else {
      // create brand new information
      this.props.saveInformation(informationRequestData, lang, () => {
        this.props.history.push('/informace');
      });
    }
  };

  render() {
    const { config } = this.props;
    const { handleSubmit } = this.props;

    return (
      <div className="new-information">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Hlavní nadpis"
            name="header"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Podnadpis"
            name="subtitle"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Hlavní obrázek"
            name="headerImageLarge"
            validate={required}
            minCropBoxWidth={588}
            aspectRatio={16 / 9}
          />
          <div className="editor">
            {/*<Editor placeholder={'Write something...'} />*/}
            <Field
              name="content"
              component={Editor}
              label="Obsah"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Url"
            name="slug"
            placeholder="nova-sluzba"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/informace" color="danger">
              Zpět na užitečné informace
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveInformation,
  updateInformation
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: INFORMATION_FORM_NAME })
)(InformationForm);



// WEBPACK FOOTER //
// ./src/modules/InformationForm/index.js